import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  return <div className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-16" data-id="element-56">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-57">
        <img src="https://cdn.magicpatterns.com/uploads/a2Bnst1zYPLimQGBi5avRH/ChatGPT_Image_15_feb_2026,_09_53_29_p.m..png" alt="Teatro Background" className="w-full h-full object-cover" data-id="element-58" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-red-900/90" data-id="element-59" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white max-w-4xl" data-id="element-60">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 backdrop-blur-sm border border-amber-400/50 rounded-full px-4 py-1.5 mb-6 animate-fade-in-up" data-id="element-61">
          <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-62" />
          <span className="text-amber-200 font-medium text-sm tracking-wide uppercase" data-id="element-63">
            El recurso #1 para docentes de teatro
          </span>
          <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-64" />
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold mb-6 leading-tight drop-shadow-lg" data-id="element-65">
          Mega Pack de Teatro: <br data-id="element-66" />
          <span className="text-amber-400" data-id="element-67">Herramientas Completas</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-68">
          Planificaciones, dinámicas y proyectos listos para usar en el aula o
          talleres. Transformá tus clases hoy mismo.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-69">
          <a href="#comprar" className="w-full sm:w-auto" data-id="element-70">
            <Button size="lg" variant="primary" className="w-full text-lg shadow-amber-900/20" data-id="element-71">
              Adquirir Ahora
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-72" />
            </Button>
          </a>
          <a href="#que-incluye" className="w-full sm:w-auto" data-id="element-73">
            <Button size="lg" variant="secondary" className="w-full text-lg bg-white/10 hover:bg-white/20 border-white/30 backdrop-blur-sm" data-id="element-74">
              Más Información
            </Button>
          </a>
        </div>
      </div>

      {/* Decorative bottom curve */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-50 to-transparent z-20" data-id="element-75" />
    </div>;
}